export const SIGNALS_PATH_NAME = 'signals';

/** @deprecated Use SIGNALS_PATH_NAME instead. Kept for backward API compatibility. */
export const LEADS_PATH_NAME = 'leads';
